import { createContext, useContext } from "react";

/** Shell + DB width for grids/skeletons (set by FeedControls). */
export type ContentLayoutValue = {
  maxWidthPercent: number;
  /** Outer shell is ~45rem (e.g. standalone component) — grid uses 4 columns. */
  narrowRemLayout: boolean;
  /** Embed landing / individual / search use the configured rem shell when active. */
  embedShellLayout?: boolean;
};

const defaultLayout: ContentLayoutValue = {
  maxWidthPercent: 100,
  narrowRemLayout: false,
};

const ContentLayoutContext = createContext<ContentLayoutValue>(defaultLayout);

export const ContentLayoutProvider = ContentLayoutContext.Provider;

/** @deprecated Use ContentLayoutProvider */
export const ContentMaxWidthPercentProvider = ContentLayoutProvider;

export function useContentLayout(): ContentLayoutValue {
  return useContext(ContentLayoutContext);
}

export function useContentMaxWidthPercent(): number {
  return useContext(ContentLayoutContext).maxWidthPercent;
}
